module.exports = __webpack_public_path__ + "static/media/aisico.46b9bdd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/aisico.png
// module id = 127
// module chunks = 0